const NFSLogo = () => (
    <svg
        focusable="false"
        viewBox="0 0 45 29"
        aria-hidden="true"
        role="presentation"
        width="45"
        height="29"
    >
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FFF"
                d="M42.995 12.882c.01.01.004.029-.011.028l-.937-.113c-5.59-.743-9.285 2.355-12.744 6.45-.905 1.072-2.56 3-3.583 4.07-2.963 3.258-7.836 6.479-12.345 3.51-.042-.028-.023-.094.026-.098 4.2-.291 6.294-2.81 8.755-5.724a248.08 248.08 0 0 1 4.339-4.934c4.08-4.448 11.004-7.702 16.5-3.189zm-6.677-4.858c.012.01.005.029-.01.029l-.937-.113c-5.59-.743-9.284 2.355-12.744 6.45-.905 1.072-2.56 2.999-3.583 4.07-2.964 3.259-7.837 6.479-12.344 3.51-.043-.029-.024-.094.025-.097 4.2-.293 6.294-2.81 8.755-5.726a247 247 0 0 1 4.339-4.932c4.078-4.449 11.004-7.703 16.5-3.19zm-6.675-4.856c.01.009.004.028-.011.028l-.937-.112c-5.59-.743-9.284 2.354-12.744 6.45-.906 1.07-2.56 2.998-3.583 4.07C9.404 16.86 4.532 20.08.023 17.112c-.042-.029-.023-.094.026-.098 4.2-.292 6.293-2.81 8.754-5.724.984-1.168 3.49-4.006 4.34-4.934 4.079-4.448 11.004-7.702 16.5-3.19z"
            />
        </g>
        <title>National Flood Services logo</title>
    </svg>
);

export default NFSLogo;
